import { Radio } from "@material-ui/core";
import styled from "styled-components";

export const VehicleRadio = styled(Radio)`
  width: 56px;
  height: 56px;
  border-radius: 5px;
  border: solid 1px #bbbbbb;
  padding: 0;

  &.disable {
    background-color: #bbbbbb;
  }

  &.Mui-checked {
    border: 1px solid #399ebf;
  }
  &.Mui-disabled {
    border: 1px solid #ececec;
  }

  &.Mui-checked::after {
    content: "";
    position: absolute;
    bottom: 5px;
    right: 5px;
    width: 5px;
    height: 5px;
    background-color: #399ebf;
    border-radius: 20px;
  }

  &.Mui-disabled::after {
    content: "";
    position: absolute;
    bottom: 5px;
    right: 5px;
    width: 5px;
    height: 5px;
    background-color: #ececec;
    border-radius: 20px;
  }
`;
export const ParcelRadio = styled(Radio)`
  width: 56px;
  height: 56px;

  &.Mui-checked {
    background-color: rgba(57, 158, 191, 0.2);
  }
  &.Mui-checked:after {
    content: "";
    position: absolute;
    font-size: 15px;
    color: #399ebf;
    bottom: 22px;
    right: 19px;
    font-weight: bold;
  }

  &:after {
    content: "";
    position: absolute;
    font-size: 15px;
    color: #c9c9c9;
    bottom: 22px;
    right: 19px;
    font-weight: bold;
  }
`;
export const ParcelRadioD = styled(Radio)`
  width: 56px;
  height: 56px;

  &.Mui-checked {
    background-color: rgba(57, 158, 191, 0.2);
  }
  &.Mui-checked:after {
    // content: "";
    position: absolute;
    font-size: 15px;
    color: #399ebf;
    bottom: 22px;
    right: 19px;
    font-weight: bold;
  }

  &:after {
    // content: "";
    position: absolute;
    font-size: 15px;
    color: #c9c9c9;
    bottom: 22px;
    right: 19px;
    font-weight: bold;
  }
`;

export const ParcelRadioM = styled(Radio)`
  width: 60px;
  height: 60px;

  &.Mui-checked {
    background-color: rgba(57, 158, 191, 0.2);
  }
  &.Mui-checked:after {
    content: "";
    position: absolute;
    font-size: 15px;
    color: #399ebf;
    bottom: 24px;
    right: 19px;
    font-weight: bold;
  }

  &:after {
    content: "";
    position: absolute;
    font-size: 15px;
    color: #c9c9c9;
    bottom: 24px;
    right: 19px;
    font-weight: bold;
  }
`;

export const ParcelRadioL = styled(Radio)`
  width: 65px;
  height: 65px;

  &.Mui-checked {
    background-color: rgba(57, 158, 191, 0.2);
  }
  &.Mui-checked:after {
    content: "";
    position: absolute;
    font-size: 15px;
    color: #399ebf;
    bottom: 26px;
    right: 22px;
    font-weight: bold;
  }

  &:after {
    content: "";
    position: absolute;
    font-size: 15px;
    color: #c9c9c9;
    bottom: 26px;
    right: 22px;
    font-weight: bold;
  }
`;

export const ParcelRadioXL = styled(Radio)`
  width: 70px;
  height: 70px;

  &.Mui-checked {
    background-color: rgba(57, 158, 191, 0.2);
  }
  &.Mui-checked:after {
    content: "";
    position: absolute;
    font-size: 15px;
    color: #399ebf;
    bottom: 27px;
    right: 19px;
    font-weight: bold;
  }

  &:after {
    content: "";
    position: absolute;
    font-size: 15px;
    color: #c9c9c9;
    bottom: 27px;
    right: 19px;
    font-weight: bold;
  }
`;

export const ParcelRadioXXL = styled(Radio)`
  width: 80px;
  height: 80px;

  &.Mui-checked {
    background-color: rgba(57, 158, 191, 0.2);
  }
  &.Mui-checked:after {
    content: "";
    position: absolute;
    font-size: 15px;
    color: #399ebf;
    bottom: 30px;
    right: 17px;
    font-weight: bold;
  }

  &:after {
    content: "";
    position: absolute;
    font-size: 15px;
    color: #c9c9c9;
    bottom: 30px;
    right: 17px;
    font-weight: bold;
  }
`;
